import {useEffect} from "react";
import {useUnblockSlot} from "@App/hooks/api/mutations/useUnblockSlot";
import {useSelector} from "react-redux";
import {State} from "@App/state";

export const useUnblockSlotOnMount = () => {

    const slot = useSelector((state: State) => state.orders.slot)

    const {unblockSlot, loading, successful} = useUnblockSlot()

    useEffect(() => {
        if (slot && slot.id) {
            unblockSlot(slot)
        }
    }, [])

    return {
        successfullyUnblockedSlot: !slot || (!loading && successful)
    }
}


